import getintouch from "../assets/svg/call.svg";
import { motion } from "framer-motion";

const ContactForm = () => {
  return (
    <motion.div
      className="flex flex-col overflow-hidden items-start bg-gray-100 p-10 md:p-[10rem] mx-auto w-full"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.2 }}
    >
      {/* Heading Section */}
      <motion.div
        className="w-full lg:ml-[65px]"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <h2 className="text-[28px] md:text-[38px] leading-[36px] md:leading-[49.4px] text-gray-900 font-bold mb-2 text-left">
          Get in Touch
        </h2>
        <p className="text-[14px] md:text-[16px] leading-[24px] md:leading-[28.8px] text-gray-900 mb-8 text-left font-semibold" >
          Have questions or inquiries? Contact us via phone or email. Our team
          is here to assist you with
          <br className="hidden md:block" /> any IT solutions you may need.
        </p>
      </motion.div>

      {/* Flex Section for SVG and Form */}
      <motion.div
        className="flex flex-col md:flex-row items-start justify-between w-full space-y-8 md:space-y-0"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
      >
        {/* Left Section - Image */}
        <motion.div
          className="md:w-1/2 w-full flex flex-col items-center"
          initial={{ scale: 0.9 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img
            src={getintouch}
            alt="Contact"
            className="w-[400px] h-[425px] md:w-[400px] md:h-[425px] mb-4"
          />
        </motion.div>

        {/* Right Section - Contact Form */}
        <motion.div
          className="w-full md:w-[553px] h-auto md:h-[360px]"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <form className="relative">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-4">
              <div className="flex flex-col w-full">
                <label className="text-[#281a39] font-semibold mb-2 text-sm md:text-base">
                  Your Name
                </label>
                <input
                  type="text"
                  className="border border-[#281a39] p-2 w-full text-gray-700 text-sm md:text-base"
                />
              </div>
              <div className="flex flex-col w-full">
                <label className="text-[#281a39] font-semibold mb-2 text-sm md:text-base">
                  Your Email
                </label>
                <input
                  type="email"
                  className="border border-[#281a39] p-2 w-full text-gray-700 text-sm md:text-base"
                />
              </div>
            </div>

            <div className="flex flex-col w-full mb-4">
              <label className="text-[#281a39] font-semibold mb-2 text-sm md:text-base">
                Subject *
              </label>
              <input
                type="text"
                className="border border-[#281a39] p-2 w-full text-gray-700 text-sm md:text-base"
                required
              />
            </div>

            <div className="flex flex-col w-full mb-4">
              <label className="text-[#281a39] font-semibold mb-2 text-sm md:text-base">
                Message
              </label>
              <textarea className="border border-[#281a39] p-2 w-full h-32 md:h-40 text-gray-700 text-sm md:text-base"></textarea>
            </div>

            {/* Send Button positioned to the bottom-right */}
            <div className="flex justify-end">
              <motion.button
                className="bg-[#281a39] text-white px-6 py-3 hover:bg-[#3a264d] transition w-full md:w-auto rounded-md text-sm md:text-base"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                Send
              </motion.button>
            </div>
          </form>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default ContactForm;
